import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es solo para psicopedagogas o también para docentes?',
  a: 'Está diseñado principalmente para psicopedagogas, pero es sumamente útil para docentes de apoyo, maestras integradoras y profesionales que trabajen con dificultades de aprendizaje.'
}, {
  q: '¿El material es editable?',
  a: 'La mayoría del material viene en formato PDF listo para imprimir y usar para garantizar la calidad visual. Sin embargo, incluimos plantillas y formatos administrativos que sí son editables para adaptarlos a tus datos.'
}, {
  q: 'Ya tengo muchos recursos de Pinterest, ¿en qué se diferencia esto?',
  a: "Pinterest ofrece actividades sueltas. El MegaPack te da un sistema secuenciado, con progresión de dificultad, plantillas de registro y rúbricas de evaluación. Es un abordaje profesional completo, no solo 'dibujos lindos'."
}, {
  q: '¿Sirve para mi sala / mi contexto específico?',
  a: 'Sí, las actividades están graduadas y pensadas para ser adaptables a diferentes contextos, ya sea consultorio privado, gabinete escolar o apoyo escolar.'
}, {
  q: 'No tengo tiempo para leer PDFs largos',
  a: 'No es teoría. Es 100% material práctico. Las instrucciones son breves y directas al punto para que puedas imprimir y aplicar inmediatamente.'
}, {
  q: '¿Incluye adecuaciones y niveles de dificultad?',
  a: 'Sí, cada módulo y tomo incluye variantes para complejizar o simplificar la tarea según el nivel del paciente o alumno.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Al confirmar el pago, recibís un mail automático con el acceso inmediato a una plataforma donde podés descargar todo el material a tu computadora o celular.'
}, {
  q: '¿Y si no me gusta?',
  a: 'Tenés 7 días de garantía. Si el material no cumple tus expectativas, nos mandás un mail y te devolvemos el dinero sin hacer preguntas.'
}, {
  q: '¿Puedo pagar en cuotas?',
  a: 'Sí, a través de Mercado Pago podés elegir la financiación que mejor se adapte a vos con tarjeta de crédito.'
}, {
  q: '¿Sirve para todo el año o solo un período?',
  a: 'El volumen de material (+1.200 páginas) está pensado para cubrir intervenciones durante todo el ciclo lectivo, con variedad suficiente para no repetir actividades.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-brand-50" data-id="element-68">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-70">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-71">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-72">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-73">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-74">
                <span className="font-bold text-gray-900 pr-4" data-id="element-75">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-600 transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-76" />
              </button>
              <AnimatePresence data-id="element-77">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-78">
                    <div className="px-6 pb-5 text-gray-600 border-t border-gray-50 pt-4" data-id="element-79">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}